import React from "react";

import { useAppStore } from "@store/appStateStore";
import {
  updateParticipant,
  fetchParticipants,
  fetchTransactions,
  fetchAttendances,
} from "@services/api";

import AgGridTable from "@components/shared/AgGridTable";
import { ActionCellRenderer } from "@components/shared/actionColumn";

import { getColumnDefs } from "./columnDefs";

const ParticipantsTable: React.FC = () => {
  const { participants, setParticipants, setTransactions, setAttendances } =
    useAppStore();

  const handleCellValueChanged = async (params: any) => {
    const { data, colDef, newValue, oldValue } = params;
    if (newValue === oldValue) return;

    const field = colDef.field;
    const updates: any = {};
    updates[field] = newValue;

    try {
      await updateParticipant(data.id, updates);

      const updatedParticipants = await fetchParticipants();
      const transactions = await fetchTransactions();
      const attendances = await fetchAttendances();

      setParticipants(updatedParticipants);
      setTransactions(transactions);
      setAttendances(attendances);
    } catch (error) {
      console.error("Ошибка:", error);
      alert("Ошибка обновления участника");
    }
  };

  const handleDeleteSuccess = async () => {
    try {
      const participants = await fetchParticipants();
      const transactions = await fetchTransactions();
      const attendances = await fetchAttendances();

      setParticipants(participants);
      setTransactions(transactions);
      setAttendances(attendances);
    } catch (error) {
      console.error("Ошибка загрузки участников после удаления:", error);
      alert("Ошибка обновления списка участников");
    }
  };

  const columnDefs = getColumnDefs(handleCellValueChanged, handleDeleteSuccess);

  return (
    <AgGridTable
      title="Участники"
      rowData={participants}
      columnDefs={columnDefs}
      components={{ ActionCellRenderer: ActionCellRenderer }}
    />
  );
};

export default ParticipantsTable;
